import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '@app/styles/themes/constants';
import { LAYOUT } from '@app/styles/themes/constants';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';

export const Sider = styled(BaseLayout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 1000;
  min-height: 100vh;
  max-height: 100vh;
  min-height: 100dvh;
  max-height: 100dvh;
  top: 0;
  /* PWA iOS: chừa status bar/tai thỏ phía trên và thanh home phía dưới. */
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.18);

  color: #c2d6d5;

  @media only screen and ${media.md} {
    right: unset;
    left: 0;
    /* Phải cao hơn header (z-index 100) để header trắng không đè lên logo sider */
    z-index: 101;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);
  }

  @media only screen and ${media.xl} {
    position: unset;
    box-shadow: none;
    z-index: auto;
  }
`;

export const CollapseButton = styled(BaseButton)<{ $isCollapsed: boolean }>`
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  transition: all 0.3s ease;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff;
  z-index: 10;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  ${(props) =>
    props.$isCollapsed &&
    css`
      top: auto;
      bottom: 0.4rem;
      right: 50%;
      transform: translateX(50%);
    `}

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.26);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    ${(props) =>
      props.$isCollapsed
        ? css`
            transform: translateX(50%) scale(1.1);
          `
        : css`
            transform: translateY(-50%) scale(1.1);
          `}
  }

  &:focus {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.26);
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
`;

export const SiderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  /* Trừ thêm 44px cho footer phiên bản (SiderVersion) để nó không bị cắt */
  max-height: calc(100vh - ${LAYOUT.mobile.headerHeight} - 44px);
  max-height: calc(
    100dvh - ${LAYOUT.mobile.headerHeight} - 44px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  );
  padding: 0 8px 16px 8px;
  /* Ẩn scrollbar mặc định, chỉ hiện khi hover vào sidebar */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  &:hover {
    scrollbar-color: rgba(255, 255, 255, 0.28) transparent;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.28);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.45);
  }

  @media only screen and ${media.md} {
    max-height: calc(100vh - ${LAYOUT.desktop.headerHeight} - 44px);
    max-height: calc(
      100dvh - ${LAYOUT.desktop.headerHeight} - 44px - env(safe-area-inset-top, 0px) -
        env(safe-area-inset-bottom, 0px)
    );
  }
`;

export const SiderLogoLink = styled(Link)<{ $collapsed?: boolean }>`
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  position: relative;

  ${(props) =>
    props.$collapsed &&
    css`
      width: 100%;
      justify-content: center;
    `}
`;

export const SiderLogoDiv = styled.div`
  height: ${LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 8px;

  @media only screen and ${media.md} {
    height: ${LAYOUT.desktop.headerHeight};
    padding-top: ${LAYOUT.desktop.paddingVertical};
    padding-bottom: ${LAYOUT.desktop.paddingVertical};
  }
`;

export const BrandSpan = styled.span`
  margin: 0 1rem;
  /* Tên shop dài wrap 2 dòng sẽ tràn khỏi khung logo — giữ 1 dòng, cắt bằng "…". */
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Hanken Grotesk', 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1.125rem;
  color: #ffffff;
`;
